import type { paths } from '../../types/authSchema';
import { authApiClient, resolveAuthApiErrorMessage } from './authApiClient';

type LoginWithCodeBody = NonNullable<
  NonNullable<
    paths['/api/v1/auth/login_with_verification_code']['post']['requestBody']
  >['content']['application/json']
>;

type LoginWithCodeSuccessResponse =
  paths['/api/v1/auth/login_with_verification_code']['post']['responses']['200']['content']['application/json'];

type LoginWithCodeErrorResponse =
  paths['/api/v1/auth/login_with_verification_code']['post']['responses']['400']['content']['application/json'];

type LoginWithCodeFallbackErrorResponse = {
  success: false;
  errorMessage: string;
};

export type LoginWithCodeResponse =
  | LoginWithCodeSuccessResponse
  | LoginWithCodeErrorResponse
  | LoginWithCodeFallbackErrorResponse;

export async function loginWithCode(
  email: string,
  verificationCode: string
): Promise<LoginWithCodeResponse> {
  const body: LoginWithCodeBody = {
    email,
    verification_code: verificationCode
  };

  try {
    const { data, error } = await authApiClient.POST('/api/v1/auth/login_with_verification_code', {
      body
    });

    if (data) {
      return data;
    }

    if (error) {
      return error;
    }

    return {
      success: false,
      errorMessage: 'Failed to login with verification code. Please try again.'
    };
  } catch (error) {
    return {
      success: false,
      errorMessage: resolveAuthApiErrorMessage(
        error,
        'Failed to login with verification code. Please try again.'
      )
    };
  }
}
